import React from 'react';
import PropTypes from 'prop-types';
import { useMeContext } from '~/modules/me';
import { PROJECT_PERMISSION } from '~/modules/common/enums';
import ResourceRequestChartBanner from '~/modules/resourcing/common/components/ResourceRequestChartBanner/ResourceRequestChartBanner';
import { supportedProjectPolicyRoles } from '~/modules/resourcing/common/hooks/useResourceRequestAllocationActions';
import { ResourceRequestSubmitAllButton } from './ResourceRequestSubmitAllButton';

export const ResourceRequestSubmitAllChartBanner = ({
  resourceRequests,
  project
}) => {
  const { userAccessRoles } = useMeContext();
  const { permittedActionUris = [] } = project;

  const isUserHasProjectPolicyRole = supportedProjectPolicyRoles.some(sr =>
    userAccessRoles.includes(sr)
  );
  const canEditProject = permittedActionUris.includes(
    PROJECT_PERMISSION.EDIT_PROJECT
  );
  const canEditTeam = permittedActionUris.includes(
    PROJECT_PERMISSION.EDIT_TEAM
  );
  const resourceRequestsFromAIIds = resourceRequests
    .filter(resourceRequest => resourceRequest.isDelaDraftResourceRequest)
    .map(resourceRequest => resourceRequest.id);

  const showBanner =
    isUserHasProjectPolicyRole &&
    canEditProject &&
    canEditTeam &&
    resourceRequestsFromAIIds.length > 0;

  return showBanner ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.submitRequests2">
      <ResourceRequestSubmitAllButton
        resourceRequestIds={resourceRequestsFromAIIds}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestSubmitAllChartBanner.propTypes = {
  project: PropTypes.object.isRequired,
  resourceRequests: PropTypes.array.isRequired
};
export default ResourceRequestSubmitAllChartBanner;
